import { useIsAppControl } from '@store/isApp'
import {
	TaboolaFeedA,
	TaboolaFeedB,
	TaboolaFeedC,
	TaboolaIssue,
	TaboolaScroll,
} from '@components/ads/Article/Taboola'
import { isWebview } from '@utils/isWebview'

interface TaboolaProps {
	type: 'feedA' | 'feedB' | 'issue' | 'feedC' | 'scroll'
}

const Taboola = ({ type }: TaboolaProps) => {
	const { isApp } = useIsAppControl()
	const isMobileWebView = isWebview()

	if (type === 'feedA' && !isApp) {
		return <TaboolaFeedA />
	}

	if (type === 'feedB' && !isApp) {
		return <TaboolaFeedB />
	}

	if (type === 'feedC' && (isMobileWebView || isApp)) {
		return <TaboolaFeedC />
	}

	if (type === 'scroll' && !isApp) {
		return <TaboolaScroll />
	}

	if (type === 'issue' && isApp) {
		return <TaboolaIssue />
	}

	return null
}
export default Taboola
